import { useEffect } from "react";
import type { Report } from "./api/index.js";
import { nameReportInUrl, useUrlFilters } from "./url-filters.js";

/**
 * Chooses a valid report and makes that fallback visible in brand-screen URLs.
 *
 * Any report handed in may be chosen, including one tracking no questions: it
 * still has the history it collected, and hiding it made a tracked brand look
 * deleted. Callers pass active reports only.
 */
export function useChosenReport(
  reports: readonly Report[],
  addressPath: string | null,
): string | null {
  const { params } = useUrlFilters();
  const asked = params.get("report");
  const chosen =
    asked !== null && reports.some((report) => report.id === asked)
      ? asked
      : (reports[0]?.id ?? null);

  useEffect(() => {
    if (chosen !== null && addressPath !== null) nameReportInUrl(addressPath, chosen);
  }, [addressPath, chosen]);

  return chosen;
}
